/**
 * 这里决定上一个页面的 urlpage 应该从哪里取
 * 如果是从 a 页面到 b 页面，则在 b 页面存储 urlpage = a，刷新页面的时候，b 仍然取 urlpage = a 的值上报
 *
 * b 页面存储 urlpage = a 的时机
 * b 在获取上一个页面 urlpage 的时候，将 urlpage 数据（如果有的话）存在 report_position_key_lastpage 中
 *
 * b 页面清空 report_position_key_lastpage 中数据的时机
 * 打开页面，判断是否登录页面，是否是相同地址的页面，如果都不是，则清除 report_position_key_lastpage 数据
 *
 * b 页面使用 report_position_key_lastpage 中数据的时机
 * b 页面打开时，判断 report_position_key_lastpage 是否有数据，有数据则用，无数据，则继续之前的逻辑，走 report_position_key 获取数据
 *
 * @Author: moonye
 * @Date: 2018-12-25 17:25:18
 * @Last Modified by: moonye
 * @Last Modified time: 2019-09-17 21:11:31
 */
import winname from './util.winname';
import util from './util';

var lastUrlpageKey = 'report_position_key_lastpage'; // 上一个页面的 urlpage 存储的地方
var urlKey = 'report_position_key_lasturl'; // 当前页面地址存储的 key
var whiteList = ['ui.ptlogin2.qq.com/cgi-bin/login', 'open.weixin.qq.com/connect/oauth2/authorize'];
var referer = document.referrer;


function isLinkEqual(link1, link2) {
  return util.delParam(link1, 'tuin') === util.delParam(link2, 'tuin');
}
var referObj = util.parseHref(referer);
var referHostAndPathname = referObj.domain + referObj.pathname;

export default {
  get: function() {
    this.del();
    var d;
    try {
      d = winname.get(lastUrlpageKey);
      d = JSON.parse(d);
    } catch (e) {}
    return d;
  },
  set: function(data) {
    var href = location.href;
    winname.set(lastUrlpageKey, JSON.stringify(data));
    winname.set(urlKey, encodeURIComponent(href));
  },
  del: function() {
    if (this.shouldClear()) {
      winname.del(lastUrlpageKey);
    }
  },
  shouldClear: function() {
    var href = location.href;
    var preUrl = winname.get(urlKey);
    return !(isLinkEqual(href, preUrl) || whiteList.indexOf(referHostAndPathname) >= 0);
  }
};
